import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api, price, shortDate } from "@/lib/api";

const origin = window.location.origin;

const EmbedEvent = ({ ev }) => (
  <div className="border border-[#E5DACA] rounded-lg bg-white p-5" data-testid={`embed-event-${ev.slug}`}>
    <div className="flex flex-wrap items-baseline justify-between gap-2">
      <h2 className="font-display text-xl text-[#1F1B17]">{ev.title}</h2>
      {ev.price_from != null && <span className="font-mono text-sm text-[#A8832F]">from {price(ev.price_from)}</span>}
    </div>
    <div className="mt-4 grid grid-cols-2 gap-2 sm:grid-cols-3">
      {ev.nights.map((n) => {
        const d = shortDate(n.date);
        return (
          <a key={n.id} href={`${origin}/events/${ev.slug}?night=${n.id}#book`} target="_top" data-testid={`embed-night-${n.id}`}
            className={`border p-3 transition-colors ${n.sold_out ? "pointer-events-none border-[#E5DACA] opacity-40" : "border-[#E5DACA] hover:border-[#C9A24B]"}`}>
            <span className="block font-display text-lg text-[#1F1B17]">{d.month} {d.day}, {d.year}</span>
            <span className="text-xs text-[#A8832F]">{ev.coming_soon ? "Coming soon" : n.sold_out ? "Sold out" : n.label || "Book"}</span>
            {n.city && <span className="block text-[11px] text-[#6B6157]">{n.city}</span>}
          </a>
        );
      })}
    </div>
    <a href={`${origin}/events/${ev.slug}#book`} target="_top" data-testid={`embed-reserve-${ev.slug}`}
      className="mt-4 block rounded bg-[#141210] py-3 text-center text-xs font-semibold uppercase tracking-widest text-[#F3DDA4] hover:bg-[#2A2520]">Reserve your seat</a>
  </div>
);

export default function Embed() {
  const { slug } = useParams();
  const [events, setEvents] = useState([]);
  useEffect(() => {
    const req = slug ? api.get(`/events/${slug}`).then((r) => [r.data]) : api.get("/events").then((r) => r.data);
    req.then(setEvents).catch(() => setEvents([]));
  }, [slug]);
  return (
    <div className="min-h-screen space-y-4 bg-[#FAF6EE] p-4" data-testid="embed-widget">
      {events.map((ev) => <EmbedEvent key={ev.id} ev={ev} />)}
    </div>
  );
}
